import axios from 'axios';
import * as config from './config';
import { Base64 } from 'js-base64';
import Helper from './helper';
import { message } from "antd";
import { v4 as uuidv4 } from "uuid";
import md5 from "md5";
import qs from "qs";

async function apicall(method, url, data) {
  let token = Helper.getParamUrlByKey('token');
  try {
    const res = await axios({
      method: method,
      url: `${config.serverOpen}${url}`,
      data: { data: Base64.encode(JSON.stringify(data)) },
      // data: data,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `bearer ${token}`,
      }
    });
    return res;
  } catch (error) {
    if (error.response) {
      message.error(
        {
          content: error.response.data.message,
          style: {
            width: '90%',
            margin:'25px auto'
          },
        },
        15
      );
    }
  };
}
async function apiCallOpen(method, url, dataForm) {
  let token = Helper.getParamUrlByKey('token') || window.location.pathname.split(".")[1] || window.location.pathname.split("/").filter(Boolean).pop() || localStorage.getItem('token');
  const queryParams = Object.entries(dataForm || {})
    .filter(([key, value]) => value !== undefined && value !== null)
    .map(([key, value]) => `${key}=${value}`)
    .join("&");
  // api lấy time và serectKey nếu có
  const dataStime = await getStime();
  if (dataStime.data.success) {
    const env = config.nodeEnv;
    const data = qs.stringify(sortObjectByKey(dataForm || {}));
    const uuid = uuidv4();
    const client = md5(env + "-" + data + dataStime.data.data.stime + uuid);
    const header = {
      "x-api-stime": dataStime.data.data.stime,
      "x-api-nonce": uuid,
      "x-api-client": client,
    }
    const res = await axios({
      method: method,
      url: `${config.serverOpen}${url}${(queryParams && method === 'GET') ? `?${queryParams}` : ""}`,
      data: dataForm,
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${token}`,
        ...header
      },
    });
    return res;
  }
}

async function getStime(method, url, data) {
  const res = await axios({
    method: 'GET',
    url: `${config.serverOpen}v1/apps/gsale/auth/secret-key`,
    data: data,
    headers: {
      "Content-Type": "application/json",
    },
  });
  return res;
}

const sortObjectByKey = (obj) => {
  const sortedKeys = Object.keys(obj).sort();
  const sortedObject = {};
  sortedKeys.forEach((key) => {
    sortedObject[key] = obj[key];
  });
  return sortedObject;
};

export default {
  apicall,
  apiCallOpen,
};